export const getIsRibbonTriggered = ({ ribbon }) => ribbon.get('isRibbonTriggered')
